/**
 * SupportedField
 *
 * @group CTA-608
 * @beta
 */
export type SupportedField = 1 | 3;
